<template>
    <div>
        <v-row>
            <v-col cols="12" md="6">
                <h1>Detalle de Alianza</h1>
            </v-col>
            <v-col cols="12" md="6" style="text-align: end;">
                <v-btn class="common-botton mr-3" dark @click="editarAlianza" v-if="canEdit">
                    <v-icon class="mr-2">mdi-pencil</v-icon>
                    <span>Editar</span>
                </v-btn>
                <v-btn class="common-botton" dark @click="$router.push('/administracion/alianzas-intermx')">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon>
                    <span>Volver</span>
                </v-btn>
            </v-col>
        </v-row>
        <v-card class="mt-5" elevation="3">
            <v-card-text>
                <div v-if="!loading">
                    <v-row>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Nombre de la alianza</span>
                            <br />
                            <span>{{
                                alianza.nombre_alianza
                                    ? alianza.nombre_alianza
                                : "No especificado"
                                }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Status</span>
                            <br />
                            <v-chip class="ml-3" :color="getStatusColor(statusLabel)" text-color="white" small>
                                {{ statusLabel }}
                            </v-chip>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Fecha inicio</span>
                            <br />
                            <span>{{
                                alianza.fecha_inicio ? alianza.fecha_inicio : "No especificado"
                                }}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Responsable</span>
                            <br />
                            <span>{{
                                alianza.nombre_responsable
                                    ? alianza.nombre_responsable
                                : "No especificado"
                                }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Canal</span>
                            <br />
                            <span>{{
                                alianza.canal ? alianza.canal : "No especificado"
                                }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Ramos</span>
                            <br />
                            <span>{{ ramosString || "No especificado" }}</span>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Agente</span>
                            <br />
                            <span>{{
                                alianza.nombre_agente
                                    ? alianza.nombre_agente
                                : "No especificado"
                                }}</span>
                        </v-col>
                        <v-col cols="4" md="4">
                            <span class="text-header-data font-weight-bold">Envios onboarding</span>
                            <br />
                            <span>{{ alianza.envios_onboarding || "No especificado" }}</span>
                        </v-col>
                        <v-col cols="4" v-if="alianza.status === 3">
                            <span class="text-header-data font-weight-bold">Fecha baja</span>
                            <br />
                            <span>{{
                                alianza.fecha_baja ? alianza.fecha_baja : "No especificado"
                                }}</span>
                        </v-col>
                        <v-col cols="4" v-if="alianza.status === 3">
                            <span class="text-header-data font-weight-bold">Motivo de baja</span>
                            <br />
                            <span>{{
                                alianza.motivo_baja ? alianza.motivo_baja : "No especificado"
                                }}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Validación de teléfono</span>
                            <br />
                            <span>{{ booleanText(alianza.validacion_telefono) }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Generar certificado</span>
                            <br />
                            <span>{{ booleanText(alianza.generar_certificado) }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Periodos fijos</span>
                            <br />
                            <span>{{ booleanText(alianza.periodos_fijos) }}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Periodo de gracia de pago</span>
                            <br />
                            <span>{{ showDaysText(alianza.periodo_gracia_pago) }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Periodo de gracia de redención</span>
                            <br />
                            <span>{{ showDaysText(alianza.periodo_gracia_redencion) }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Redención sin emisión</span>
                            <br />
                            <span>{{ booleanText(alianza.redencion_sin_emision) }}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <span class="text-header-data font-weight-bold">URL certificado aseguradora</span>
                            <br />
                            <a v-if="alianza.url_certificado_aseguradora" :href="alianza.url_certificado_aseguradora" target="_blank" rel="noopener">
                                {{ alianza.url_certificado_aseguradora }}
                            </a>
                            <span v-else>No especificado</span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Creado Por</span>
                            <br />
                            <span>{{ alianza.creadoPor || "No especificado" }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Fecha de creación</span>
                            <br />
                            <span>{{ alianza.fechaCreacion ? cleanDate(alianza.fechaCreacion) : "No especificado"
                                }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Modificado Por</span>
                            <br />
                            <span>{{ alianza.modificadoPor || "No especificado" }}</span>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-header-data font-weight-bold">Última Modificación</span>
                            <br />
                            <span>{{ alianza.ultimaModificacion ? cleanDate(alianza.ultimaModificacion) : "No especificado" }}</span>
                        </v-col>
                    </v-row>

                </div>

                <v-container v-else>
                    <v-row justify="center" class="pa-5">
                        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { getAlianzaById } from "@/services/alianzas/alianzas.service";
import { getCanalList } from "@/services/canal/canal.service.js";
import { getRamoList } from "@/services/ramo/ramo.service.js";
export default {
    name: "DetalleAlianzaInterMx",
    components: {},
    data() {
        return {
            loading: true,
            statusAlianzas: [
                { id: 1, value: "Activo" },
                { id: 2, value: "Inactivo" },
                { id: 3, value: "Baja" },
            ],
            alianza: {},
            ramos: [],
            ramosString: "",
            canales: [],
            rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
            roles: JSON.parse(localStorage.getItem("roles")),
        };
    },
    computed: {
        canEdit() {
            let canEdit = false;
            let roles = [];
            this.roles.forEach((element) => {
                roles.push(element.rol);
            });
            const rolesConPermiso = ["ADMIN", "MANAGERCC", "OPERADOR"];
            roles.forEach((element) => {
                if (rolesConPermiso.includes(element)) {
                    canEdit = true;
                }
            });
            return canEdit;
        },
        statusLabel() {
            const item = this.statusAlianzas.find(
                (i) => i.id === this.alianza.status
            );
            return item && item.value ? item.value : "Desconocido";
        },
    },
    async mounted() {
        this.loading = true;
        await this.getRamos();
        await this.getCanales();
        this.getAlianzaInfo();
    },
    methods: {
        getAlianzaInfo() {
            getAlianzaById(this.$route.params.id)
                .then((response) => {
                    const alianzaData = response.alianza;
                    this.alianza = {
                        nombre_alianza: alianzaData.nombre,
                        status: alianzaData.status,
                        fecha_inicio: this.cleanDate(alianzaData.fecha_inicio),
                        responsable_id: alianzaData.responsableId,
                        creadoPor: alianzaData.creadoPor,
                        fechaCreacion: alianzaData.fechaCreacion,
                        modificadoPor: alianzaData.modificadoPor,
                        ultimaModificacion: alianzaData.ultimaModificacion,
                        fecha_baja: this.cleanDate(alianzaData.fecha_baja),
                        motivo_baja: alianzaData.motivoBaja,
                        agente_id: alianzaData.agenteId,
                        envios_onboarding: alianzaData.enviosOnboarding,
                        canal:
                            (this.canales.find((c) => c.id === alianzaData.canal) || {})
                                .canal || "No especificado",
                        ramo: alianzaData.ramosList,
                        //campos no necesarios para el payload
                        nombre_responsable: alianzaData.nombreResponsable,
                        nombre_agente: alianzaData.nombreAgente,
                        validacion_telefono: alianzaData.validacionTelefono,
                        generar_certificado: alianzaData.generarCertificado,
                        url_certificado_aseguradora: alianzaData.urlCertificadoAseguradora,
                        periodos_fijos: alianzaData.periodosFijos,
                        periodo_gracia_pago: alianzaData.periodoGraciaPago,
                        periodo_gracia_redencion: alianzaData.periodoGraciaRedencion,
                        redencion_sin_emision: alianzaData.redencionSinEmision,
                    };
                    this.ramosString = this.alianza.ramo.map(r => r.etiqueta).join(', ');
                    this.loading = false;
                })
                .catch((error) => {
                    this.$toast.error(
                        "Error al cargar la alianza, verifica el id ingresado o reporta al equipo de soporte en caso de problemas " +
                        error.message,
                        {
                            position: "top-right",
                            timeout: 4000,
                        }
                    );
                    setTimeout(() => {
                        this.$router.push("/administracion/alianzas-intermx");
                    }, 4000);
                });
        },
        cleanDate(fechaString) {
            if (!fechaString) return null;
            // Para fechas que incluyen la hora (yyyy-mm-dd hh:mm:ss)
            const date = new Date(fechaString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
        },
        getStatusColor(status) {
            const statusColors = {
                Activo: "green",
                Inactivo: "amber darken-2",
                Baja: "red",
            };
            return statusColors[status] || "grey";
        },
        editarAlianza() {
            this.$router.push(
                `/administracion/alianzas-intermx/editar/${this.$route.params.id}`
            );
        },
        async getRamos() {
            this.ramos = await getRamoList();
        },
        async getCanales() {
            this.canales = await getCanalList();
        },
        booleanText(valor) {
            if (valor === null || valor === undefined) return "No especificado";
            return valor === true || valor === 1 ? "Sí" : "No";
        },
        showDaysText(valor) {
            if (valor === null || valor === undefined || valor === "") return "No especificado";
            return `${valor} días`;
        },
    },
};
</script>

<style scoped>
.text-header-data {
    color: #00a7e4;
    font-size: 14px;
}

h3 {
    color: #00a7e4;
    font-size: 18px;
}

.v-card {
    border-radius: 8px;
}
</style>